import { ListPickupV2 } from "@/domain/entities/ListPickupV2";

interface BuildDhlLabelPrintListColumnParams {
  rows: ListPickupV2[];
  t: (key: string) => string;
  onPrint: (item: ListPickupV2) => void;
}

const buildDhlLabelPrintListColumn = ({
  rows,
  t,
  onPrint
}: BuildDhlLabelPrintListColumnParams) => {
  if (!rows.some((row) => row.isDhlFirstMilePrintEnabled)) {
    return [];
  }

  return [
    {
      name: "Print",
      key: "button_column",
      styleHead: "w-20",
      headerId: "pickup-list-col-print-action",
      styleButton: (item: ListPickupV2) => {
        if (!item.canPrintDhlLabel) {
          return null;
        }
        return {
          flat: true,
          icon: "ics_o_print",
          textColor: "gray-lp-600",
          color: "gray-lp-600",
          "data-testid": `pickup-list-row-${item.shipmentId}-print-icon`,
          toolTip: t("pickup.printLabel"),
          clickFunction: () => onPrint(item)
        };
      }
    }
  ];
};

export default buildDhlLabelPrintListColumn;
